import { render, staticRenderFns } from "./StatusCadastrosTable.vue?vue&type=template&id=2e59b800&scoped=true&"
import script from "./StatusCadastrosTable.vue?vue&type=script&lang=js&"
export * from "./StatusCadastrosTable.vue?vue&type=script&lang=js&"
import style0 from "./StatusCadastrosTable.vue?vue&type=style&index=0&id=2e59b800&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e59b800",
  null
  
)

export default component.exports